import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year', label: '대상년도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear(),
          afterFix: '년',
        }
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["대상년도", "선임일", "최근 교육일", "차기 교육일", "이수증"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "법령",
        key: "body.subInfo.법령",
      },
      {
        name: "구분",
        key: "body.구분",
      },
      {
        name: "선임일",
        key: "body.subInfo.선임일",
      },
      {
        name: "이름",
        key: "body.subInfo.이름",
      },
      {
        name: "최근 교육일",
        key: "body.subInfo.최근교육일",
      },
      {
        name: "차기 교육일",
        key: "body.subInfo.차기교육일",
      },
      {
        name: "이수증",
        key: "body.subInfo.교육이수증",
        style: { minWidth: "120px" },
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0: return postContent.header.year; // 대상년도
        case 1: return func.getContent(value).stdInfo.field_name // 사업장명
        case 2: return func.getContent(value).subInfo.법령 // 법령
        case 3: return func.getContent(value).구분 // 구분
        case 4: return func.getContent(value).subInfo.선임일 // 선임일
        case 5: return func.getContent(value).subInfo.이름 // 이름
        case 6: return func.getContent(value).subInfo.최근교육일 // 최근교육일
        case 7: return func.getContent(value).subInfo.차기교육일 // 차기교육일
        case 8: { // 이수증
          const file = func.getContent(value).subInfo.교육이수증
          return  {
            type: 'docsIcon',
            file: file,
          }
        }
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
